// 공유 BlockNote 스키마(Phase C).
//
// ⚠️ 블래스트 반경 주의: 이 스키마는 모든 페이지 에디터에 적용된다.
//    라이브 에디터(PageEditor.jsx, useCreateBlockNote)와 헤드리스 변환기
//    (markdownToYstate.js, BlockNoteEditor.create)가 반드시 같은 schema 를
//    써야 Yjs 직렬화/역직렬화가 호환된다. 그래서 이 모듈 하나에서만 정의하고
//    양쪽이 import 해 쓴다.
//
//    기본 블록(paragraph/heading/image/list/table/code 등)은 defaultBlockSpecs 를
//    그대로 spread 해 유지하고, linkedDatabaseView(노션 링크드 뷰 인라인 임베드)만 추가한다.
//
// 🔧 2026-06-18: linkedDatabaseViewSpec 이 createReactBlockSpec 의 "생성 함수"를
//    () 로 호출해 만든 실제 BlockSpec 객체여야 한다(LinkedDatabaseView.jsx 참조).
//    호출 누락 시 에디터 초기화 런타임 크래시. 샌드박스 node 런타임으로 재검증 완료.

import { BlockNoteSchema, defaultBlockSpecs } from '@blocknote/core';
import { withMultiColumn } from '@blocknote/xl-multi-column';
import { linkedDatabaseViewSpec } from './LinkedDatabaseView';
import { calloutSpec } from './Callout';
import { equationSpec } from './Equation';
import { bookmarkSpec } from './Bookmark';
import { syncedBlockSpec } from './SyncedBlock';
import { embedSpec } from './Embed';

// 2026-07-06 멀티 컬럼 — @blocknote/xl-multi-column(0.51.4, 다른 @blocknote/* 와 버전 고정)의
// withMultiColumn 으로 columnList/column 블록을 합성. 이 스키마는 라이브 에디터·공개 페이지·
// 임포터가 공유하므로 여기 한 곳만 확장하면 전부 적용된다.
// (라이선스: GPL-3.0 OR PROPRIETARY 듀얼 — 사내 내부 툴 용도)
export const schema = withMultiColumn(BlockNoteSchema.create({
  blockSpecs: {
    ...defaultBlockSpecs,
    linkedDatabaseView: linkedDatabaseViewSpec,
    callout: calloutSpec,
    // 2026-07-05 커스텀 블록 4종 — 각 spec 파일에서 createReactBlockSpec(...)() 호출 완료본.
    equation: equationSpec,
    bookmark: bookmarkSpec,
    syncedBlock: syncedBlockSpec,
    embed: embedSpec,
  },
}));

// 스키마에 linkedDatabaseView 가 실제로 등록됐는지. markdownToYstate 가 이 플래그로
// 마커 치환 여부를 결정해, 스키마에 없는 블록을 만들어 import 가 깨지는 걸 막는다.
export const HAS_LINKED_VIEW = !!schema.blockSchema?.linkedDatabaseView;

// 멀티 컬럼(columnList/column)이 스키마에 실제 등록됐는지 — markdownToYstate 가 이 플래그로
// :::cols-start:::/:::col-start::: 마커 치환 여부를 결정한다(미등록 시 평탄화 폴백).
export const HAS_COLUMNS = !!(schema.blockSchema?.columnList && schema.blockSchema?.column);

export default schema;
